import React from 'react';
import PropTypes from 'prop-types';

import NumberTextField from 'components/NumberTextfield';

import Label from 'ui/text/Label';

const RenewalMonthsInput = ({ renewal_months, onChange, disabled }) => {
  return (
    <>
      <NumberTextField
        fullWidth
        size='small'
        name='renewal_months'
        label={'Maximum number of payments'}
        color="warning"
        value={renewal_months}
        onChange={onChange}
        disabled={disabled}
      />
      <Label secondary padded>Leave empty for unlimited. Includes initial payment (e.g., 2 payments = 2 months active)</Label>
    </>
  );
};

RenewalMonthsInput.propTypes = {
  renewal_months: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RenewalMonthsInput;
